var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divMyDocumentsWrapper"}},[_c('div',{staticClass:"content-row"},[_c('VueWrapperNarrow',[_c('VueFaqAccordion',{attrs:{"items":_vm.items},on:{"itemSelect":_vm.openItem}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }